import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_app/')({
  beforeLoad: ({ context }) => {
    switch (true) {
      case context.permissions?.records?.can?.view:
        throw redirect({ to: '/records' });
      case context.permissions?.deals?.can?.view:
        throw redirect({ to: '/pipeline' });
      case context.permissions?.agents?.can?.view:
        throw redirect({ to: '/agents' });
      case context.permissions?.analytics?.can?.view:
        throw redirect({ to: '/analytics' });
      default:
        throw redirect({ to: '/settings' });
    }
  },
});
